import { render, staticRenderFns } from "./LandingMerchantHero.vue?vue&type=template&id=59fb5126&scoped=true"
import script from "./LandingMerchantHero.vue?vue&type=script&lang=js"
export * from "./LandingMerchantHero.vue?vue&type=script&lang=js"
import style0 from "./LandingMerchantHero.vue?vue&type=style&index=0&id=59fb5126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb5126",
  null
  
)

export default component.exports